import {Group, Table, TableTdProps} from '@mantine/core';
import {DateTime} from 'luxon';
import {JobDetailDto} from '../api/generated/index.defs';
import classes from './job-details.module.css';
import {trimSerialNumber} from '../utils/string-helpers';
import React from 'react';
import {formatJSDate} from '../utils/luxon.ts';

type JobDetailsProps = {
  job: JobDetailDto | null | undefined;
};

const TableLabel = React.memo(
  ({children, ...rest}: {children?: React.ReactNode} & TableTdProps) => (
    <Table.Td w={200} {...rest}>
      {children}
    </Table.Td>
  ),
);

const TableData = React.memo(
  ({children, ...rest}: {children?: React.ReactNode} & TableTdProps) => (
    <Table.Td fw='600' {...rest}>
      {children}
    </Table.Td>
  ),
);

export const JobDetails: React.FC<JobDetailsProps> = ({job}) => {
  return (
    <>
      <Table withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th fw='normal' colSpan={4} className={classes.tableHeader}>
              Job Details
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <TableLabel>Job Id</TableLabel>
            <TableData>{job?.id}</TableData>

            <TableLabel>Job Status</TableLabel>
            <TableData>{job?.status}</TableData>
          </Table.Tr>

          <Table.Tr>
            <TableLabel>Serial Number</TableLabel>
            <TableData>{trimSerialNumber(job?.serialNumber)}</TableData>

            <TableLabel>Production Date</TableLabel>
            <TableData>
              <Group gap={6}>
                {job?.productionDate
                  ? formatJSDate(job.productionDate, DateTime.DATE_SHORT)
                  : 'N/A'}
              </Group>
            </TableData>
          </Table.Tr>

          <Table.Tr>
            <TableLabel>Level of Service</TableLabel>
            <TableData>{job?.levelOfServiceDescription}</TableData>

            <TableLabel>Created Date / By</TableLabel>
            <TableData>
              <Group gap={6}>
                {job?.createdDate
                  ? formatJSDate(job.createdDate, DateTime.DATE_SHORT)
                  : 'N/A'}
                {job?.createdByUser && <div>|</div>}
                {job?.createdByUser}
              </Group>
            </TableData>
          </Table.Tr>

          <Table.Tr>
            <TableLabel>Part Number</TableLabel>
            <TableData>{job?.partNumber}</TableData>

            <TableLabel>Modified Date / By</TableLabel>
            <TableData>
              <Group gap={6}>
                {job?.modifiedDate
                  ? formatJSDate(job.modifiedDate, DateTime.DATE_SHORT)
                  : 'N/A'}
                {job?.modifiedByUser && <div>|</div>}
                {job?.modifiedByUser}
              </Group>
            </TableData>
          </Table.Tr>

          <Table.Tr>
            <TableLabel>Part Description</TableLabel>
            <TableData colSpan={3}>{job?.partDescription}</TableData>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </>
  );
};
